import React from 'react';
import styled from 'styled-components';
import { string, func, oneOfType, element } from 'prop-types';
import Row from '../Container/Row';
import { BodyText, CaptionText } from '../Text/Heading';
import Icon from '../Icon';

const HeaderWrapper = styled(Row)`
  height: 56px;
  align-items: center;
  top: 0;
  width: 100%;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.2);
  background-color: ${({ theme }) => theme.colors.primaryWhite};
  position: fixed;
  z-index: 12;
`;
HeaderWrapper.defaultProps = {
  display: ['flex', 'none'],
};

const LeftIcon = styled(Icon)`
  width: 24px;
  height: 24px;
  margin: 16px;
  color: ${({ theme }) => theme.colors.greyDark};
`;
LeftIcon.displayName = 'LeftIcon';

const RightItemWrapper = styled(Row)`
  margin: 16px;
  justify-content: flex-end;
`;

const TextWrapper = styled(Row)`
  flex-direction: column;
  flex: 1;
  overflow: hidden;
`;

const MobileNavHeader = ({
  title,
  subTitle,
  onClick,
  className,
  rightItem,
}) => {
  return (
    <HeaderWrapper className={className}>
      <LeftIcon
        onClick={onClick}
        icon="ArrowBackIcon"
        fontsize="titleNormal"
        className="mobile-back-button"
      />
      <TextWrapper>
        <BodyText
          lineHeight="20px"
          className="mobile-header-title"
          numberOfLines={1}
          ellipsizeMode="tail"
        >
          {title}
        </BodyText>
        {subTitle && (
          <CaptionText
            className="mobile-header-subtitle"
            lineHeight={['16px', '18px']}
            fontSize={[12, 14]}
            numberOfLines={1}
            ellipsizeMode="tail"
          >
            {subTitle}
          </CaptionText>
        )}
      </TextWrapper>
      {rightItem && <RightItemWrapper>{rightItem}</RightItemWrapper>}
    </HeaderWrapper>
  );
};

MobileNavHeader.propTypes = {
  title: oneOfType([string, element]),
  subTitle: oneOfType([string, element]),
  onClick: func,
  className: string,
  onChangeCurrency: func,
  rightItem: element,
};

export default MobileNavHeader;
